module.exports = __webpack_public_path__ + "img/payment_flow.ed89e3ff.png";